import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-creating-unicorn',
  templateUrl: './creating-unicorn.component.html',
  styleUrls: ['./creating-unicorn.component.scss']
})
export class CreatingUnicornComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
